import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { FabricImage } from "@/components/FabricImage";
import { Pencil, Trash2 } from "lucide-react";

const num = (v) => Number(v) || 0;

export const FabricRow = ({ item, selected, onToggle, onEdit, onDelete, onPreview }) => {
  const low = num(item.min_stock) > 0 && num(item.than_stock) < num(item.min_stock);
  return (
    <tr
      data-testid={`fabric-row-${item.id}`}
      className={`border-b border-zinc-200 transition-colors hover:bg-zinc-50 ${selected ? "bg-amber-50/60" : "bg-white"}`}
    >
      <td className="px-3 py-2">
        <Checkbox
          data-testid={`fabric-select-${item.id}`}
          checked={selected}
          onCheckedChange={() => onToggle(item.id)}
          className="h-4 w-4 rounded-sm border-zinc-400 data-[state=checked]:bg-zinc-950"
        />
      </td>
      <td className="hidden px-2 py-2 sm:table-cell">
        <FabricImage
          path={item.image_path}
          alt={`${item.quality_name} shade ${item.shade_number}`}
          className="h-10 w-10 shrink-0 cursor-zoom-in border border-zinc-200 object-cover"
          w={200}
          onClick={() => onPreview?.(item)}
          data-testid={`fabric-preview-${item.id}`}
        />
      </td>
      <td className="px-3 py-2 font-mono-num text-sm font-semibold">{item.shade_number || "-"}</td>
      <td className="px-3 py-2 text-sm font-medium whitespace-nowrap">{item.quality_name || "-"}</td>
      <td className="hidden px-3 py-2 text-sm text-zinc-600 md:table-cell">{item.colour || "-"}</td>
      <td className="hidden px-3 py-2 text-sm text-zinc-600 lg:table-cell">{item.company_name || "-"}</td>
      <td className="hidden px-3 py-2 text-xs uppercase tracking-[0.12em] text-zinc-500 sm:table-cell">
        {item.centre || "-"}
      </td>
      <td
        className={`px-3 py-2 text-right font-mono-num text-sm font-semibold ${
          num(item.than_stock) < 0 ? "text-red-600" : low ? "text-amber-600" : ""
        }`}
      >
        {item.than_stock ?? 0}
      </td>
      <td
        className={`px-3 py-2 text-right font-mono-num text-sm font-semibold ${
          num(item.meter_stock) < 0 ? "text-red-600" : ""
        }`}
      >
        {item.meter_stock ?? 0}
      </td>
      <td className="hidden px-3 py-2 text-right font-mono-num text-sm text-zinc-600 lg:table-cell">
        {item.wsr ? `₹${item.wsr}` : "-"}
      </td>
      <td className="hidden px-3 py-2 text-right font-mono-num text-sm text-zinc-600 xl:table-cell">
        ₹{Math.round(num(item.meter_stock) * num(item.purchase_price)).toLocaleString("en-IN")}
      </td>
      <td className="px-2 py-2">
        <div className="flex justify-end gap-1">
          <Button
            data-testid={`fabric-edit-${item.id}`}
            size="icon"
            variant="ghost"
            className="h-7 w-7 rounded-sm"
            onClick={() => onEdit(item)}
          >
            <Pencil size={13} />
          </Button>
          <Button
            data-testid={`fabric-delete-${item.id}`}
            size="icon"
            variant="ghost"
            className="h-7 w-7 rounded-sm text-red-600 hover:text-red-700"
            onClick={() => onDelete(item)}
          >
            <Trash2 size={13} />
          </Button>
        </div>
      </td>
    </tr>
  );
};
